import { AxiosError } from "axios";
import { PaginateResult } from "core/resources/types/shared";
import { useQuery } from "react-query";
import { AnuncioDto, ListarAnuncioQuery } from "../typings";
import http from "infra/http";

export function useListarAnuncios(query: ListarAnuncioQuery) {
  return useQuery<PaginateResult<AnuncioDto>, AxiosError>(
    `/v1/anuncio-${query.search}-${query.page}-${query.limit}-${query.statusId}`,
    async () => {
      const { data } = await http.get<PaginateResult<AnuncioDto>>(
        "/v1/anuncio", {
          params: query,
        }
      );

      return data;
    }
  );
}
